module.exports = __webpack_public_path__ + "img/entrepreneur-1340649_1920.56536f79.jpg";